<template>
  <div class="about">
    <youtube :video-id="'KQOFL8GRdxQ'"
             class="youtube-box"
             player-width="100%"
             player-height="100%"></youtube>
  </div>
</template>

<script>
  export default {
    created: function () {
    },
    methods: {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .about {
    width: 100vw;
    min-height: 100vh;
    padding-top: 63px;
  }
  .youtube-box {
    width: 100vw;
    max-width: 640px;
    height: 75vw;
    max-height: 360px;
    margin: auto;
    background: #ebebeb url('../../static/img/preload.gif') no-repeat center center;
    background-size: auto;
  }
  /*styles for smaller screens*/
  @media (max-width: 767px) {
  }
</style>



// WEBPACK FOOTER //
// About.vue?30a4e952